import React from 'react';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import QueryStringService from '../../services/queryStringService.js';
import ExportService from '../../services/exportService.js';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import * as consts from '../../models/consts.js'
export default class SpotplanIDSExportButton extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.country = this.queryStringService.getCurrentCountry();
        this.exportService = new ExportService();

        this.state = {
            exportingSpotplan: false
        };

        this.exportToExcel = this.exportToExcel.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    exportToExcel() {

        if (this.props.exportAllowed !== undefined && this.props.exportAllowed.toLowerCase() === 'no') {
            toast.info("Not possible to export IDS file for this product");
            console.log("Not possible to export IDS file for this product");
            return;
        }

        this.setState({
            exportingSpotplan: true
        });

        this.exportService.getSpotplan(this.props.spotlength, this.props.targetSoV, (spotplanData) => {

            try {

                if (!spotplanData) {
                    console.log("No data while exporting spotplan");
                    return;
                }
                let file = new Blob([spotplanData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const fileExtension = '.xlsx';
                const fileName = 'PoP-spotplan-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension;

                const ua = window.navigator.userAgent;
                if (ua.match(/Edge/)) {
                    window.navigator.msSaveBlob(file, filename);
                } else {
                    FileSaver.saveAs(file, fileName);
                }

                this.setState({ exportingSpotplan: false });
            }
            catch (ex) {
                this.setState({ exportingSpotplan: false });
                console.error("Error while downloading and saving the spotplan to the browser.", ex);
                toast.error(<div>Something went wrong while trying to export the spotplan!<br />Try again or contact support.</div>);
            }

        }, (error) => {
            this.setState({ exportingSpotplan: false });

            console.error("Error while exporting spotplan", error);
            toast.error(<div>Something went wrong while trying to export the spotplan!<br/>Try again or contact support.</div>);
        });
    }

    render() {
        let colorClass = 'btn-play';
        if (this.props.campaignType !== undefined && this.props.campaignType.toLowerCase() === 'posting') {
            colorClass = 'btn-posting';
        }
        let showLoadingIcon = this.props.showLoadingIcon !== undefined && this.props.showLoadingIcon;

        return (
            <div >
                <button disabled={!this.props.allowSpotplanExport} className={'btn ' + colorClass + ' hidden-print'}
                    style={this.props.style}
                    //style={{ marginTop: '2px', marginLeft: '10px', minWidth: showLoadingIcon && "140px" }}
                    target='_blank'
                    onClick={() => { this.exportToExcel() }}>
                    Spotplan to IDS{this.country !== consts.Countries.dk ? '*' : ''}
                    {this.state.exportingSpotplan && showLoadingIcon &&
                        <FontAwesomeIcon icon={faSpinner} spin size="xs" fixedWidth />
                    }
                </button>
            </div>
        );
    }
}